import FormatConnectionCode from './FormatConnectionCode'

export default FormatConnectionCode



// WEBPACK FOOTER //
// ./src/legacy/components/FormatConnectionCode/index.js